let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Qf3VH")).then(() => parcelRequire('8jbH9'));